<template>
  <div class="contact-page">
    <section class="hero">
      <div class="container">
        <div class="hero-content">
          <h1></h1>
          <p></p>
        </div>
      </div>
    </section>

    <section class="contact">
      <div class="container">
        <div class="contact-form">
          <form @submit.prevent="submitForm" class="flex-row">
            <div class="form-group flex-row">
              <label for="name">Name</label>
              <input type="text" id="name" v-model="form.name" placeholder="Name" required>
            </div>

            <div class="form-group flex-row">
              <label for="email">Email</label>
              <input type="email" id="email" v-model="form.email" placeholder="Name" required>
            </div>

            <div class="form-group flex-row">
              <label for="company">Company</label>
              <input type="text" id="company" v-model="form.company" placeholder="Name" required>
            </div>

            <div class="form-group flex-row">
              <label for="message">Message</label>
              <input type="text" id="message" v-model="form.message" placeholder="Name" required>
            </div>

            <button type="submit" class="submit-btn">SEND MESSAGE</button>
          </form>
          
        </div>
      </div>
    </section>
    
    <!-- Success Modal -->
    <div class="modal-overlay" :class="{ active: showModal }">
      <div class="modal-content">
        <div class="modal-icon">✓</div>
        <h2 class="modal-title">Message Received!</h2>
        <p class="modal-message">Thank you for contacting us. We have received your message and will get back to you within 24 hours.</p>
        <button class="modal-close-btn" @click="closeModal">Close</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactPage',
  data() {
    return {
      form: {
        name: '',
        email: '',
        company: '',
        message: ''
      },
      showModal: false
    }
  },
  methods: {
    submitForm() {
      // In reality, this would send form data to the server
      console.log('Form submitted:', this.form);
      
      // Show success modal
      this.showModal = true;
      
      // Reset form
      this.form = {
        name: '',
        email: '',
        company: '',
        message: ''
      };
    },
    closeModal() {
      this.showModal = false;
    }
  }
}
</script>

<style scoped>
.contact-page {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.hero {
  width: 100%;
  background-size: cover;
  background-position: center;
  color: white;
  padding: 8rem 0 8rem 0; 
  padding-top: calc(8rem + 100px);
  text-align: center;
  position: relative;
  background-image: url("../assets/images/contact us.png");
}

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0);
  z-index: 1;
}

.hero-content {
  position: relative;
  z-index: 2;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  padding: 0 1rem;
}

.hero h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.hero p {
  font-size: 1.2rem;
}

.contact {
  background-color: black;
  color: white;
  padding: 6rem 0;
  width: 100%;
  flex: 1; /* Expand to fill remaining space */
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.container {
  display: flex;
  gap: 3rem;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
  flex-wrap: wrap;
  
}

.contact-info {
  flex: 1;
  min-width: 300px;
  
}

.contact-form {
  flex: 2;
  display: flex;
  justify-content: center;
  width: 100%;
  
}

.contact-form form {
  width: 100%;
  max-width: 600px;
}

.info-section {
  margin-bottom: 2rem;
}

.info-section h2,
.info-section h3 {
  margin-bottom: 1rem;
}

.info-section p {
  color: #aaa;
  line-height: 1.6;
}

.form-group {
  margin-bottom: 1.5rem;
  font-family: PingFangSC, PingFang SC;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;
  margin-right: 10px;
}

.form-group input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #333;
  border-radius: 4px;
  background-color: #111;
  color: white;
  font-size: 1rem;
}

.form-group.flex-row {
  display: flex;
  align-items: center;
  gap: 1rem;
  text-align: right;
}

.form-group.flex-row label {
  flex: 0 0 auto;
  width: 80px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 18px;
  color: #FFFFFF;
  line-height: 25px;
  font-style: normal;
  margin-right: 20px;
  margin-left: 10px;
  text-align: right;
}

.form-group.flex-row input {
  flex: 1;
  width: 100%;
  max-width: 500px;
  height: 43px;
  background: #101010;
  border-radius: 2px;
  border: 1px solid #979797;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--primary-color);
}

.submit-btn {
  width: 100%;
  max-width: 234px;
  height: 42px;
  background: linear-gradient(225deg, #46FAB8 0%, #1CC9A5 47%, #505BFF 100%);
  border-radius: 2px;
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.3s;
  display: block;
  margin-left: 250px;
}

.submit-btn:hover {
  background-color: var(--secondary-color);
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.modal-overlay.active {
  opacity: 1;
  visibility: visible;
}

.modal-content {
  background: linear-gradient(135deg, #1a1a1a, #2d2d2d);
  border-radius: 12px;
  padding: 2.5rem;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
  transform: translateY(-50px);
  transition: transform 0.5s ease;
  text-align: center;
  border: 1px solid #333;
}

.modal-overlay.active .modal-content {
  transform: translateY(0);
}

.modal-icon {
  font-size: 4rem;
  color: #10b981;
  margin-bottom: 1.5rem;
}

.modal-title {
  font-size: 1.8rem;
  margin-bottom: 1rem;
  color: #fff;
}

.modal-message {
  color: #ccc;
  margin-bottom: 2rem;
  line-height: 1.6;
}

.modal-close-btn {
  background-color: var(--primary-color);
  color: white;
  border: none;
  
  border-radius: 25px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: bold;
  transition: all 0.3s;
  text-align: center;
}

.modal-close-btn:hover {
  background-color: var(--secondary-color);
  transform: scale(1.05);
}

@media (max-width: 768px) {
  .container {
    flex-direction: column;
  }
  
  .form-group.flex-row {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .form-group.flex-row label {
    width: 100%;
    text-align: left;
    margin-left: 0;
  }
  
  .form-group.flex-row input {
    max-width: 100%;
  }
  
  .submit-btn {
    margin: 0 auto;
  }
  
  .modal-content {
    padding: 1.5rem;
  }
  
  .modal-title {
    font-size: 1.5rem;
  }
}
</style>